import { Button } from "../design/button";
import { Divider } from "../design/divider";
import { Fieldset } from "../design/fieldset";
import { Heading, Subheading } from "../design/heading";
import LogoHorizontal from "../components/LogoHorizontal";

const LandingPage: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
      <div className="w-full max-w-3xl p-8 text-center bg-white rounded-lg shadow-lg dark:bg-gray-800">
        {/* Logo */}
        <div className="mb-6">
          <LogoHorizontal className="h-10 mx-auto" />
        </div>

        {/* Headline Section */}
        <Fieldset>
          <Heading className="text-3xl font-semibold">
            Stay Organized. Stay Ahead.
          </Heading>
          <Subheading className="mt-2 text-lg">
            Legal battles are tough. Keeping records shouldn’t be. CaseTime
            helps you document, organize, and prepare—so you can focus on what
            matters.
          </Subheading>
          <p className="mt-2 font-semibold text-red-600">
            🚀 Join our beta now and take control of your matter!
          </p>

          <Divider className="my-6" />
          <Button color="blue" href="/register" className="w-full">
            Sign Up for Free
          </Button>
        </Fieldset>

        {/* Why CaseTime Section */}
        <div className="mt-10 text-left">
          <Heading className="text-2xl font-semibold">Why CaseTime?</Heading>
          <p className="mt-4 text-lg text-gray-700 dark:text-gray-300">
            CaseTime gives you the tools to document events, track evidence, and
            build your matter with confidence.
          </p>
          <ul className="mt-4 text-lg text-gray-700 list-disc list-inside dark:text-gray-300">
            <li>✅ Log key events and disputes.</li>
            <li>✅ Organize and store crucial documents.</li>
            <li>✅ AI-powered summaries for legal clarity.</li>
            <li>✅ Securely share files with your lawyer.</li>
          </ul>
        </div>

        {/* Testimonials Section */}
        <div className="mt-10 text-left">
          <Heading className="text-2xl font-semibold">
            What Users Are Saying
          </Heading>
          <blockquote className="mt-4 italic text-gray-700 dark:text-gray-300">
            "CaseTime made my custody matter so much easier. The AI-generated
            reports kept everything clear and organized."
            <br />
            <span className="font-bold">— Mike T.</span>
          </blockquote>
          <blockquote className="mt-4 italic text-gray-700 dark:text-gray-300">
            "I had proof of every event, which made all the difference in
            court."
            <br />
            <span className="font-bold">— Sarah P.</span>
          </blockquote>
        </div>

        {/* Final CTA Section */}
        <div className="mt-10 text-center">
          <Heading className="text-2xl font-semibold">
            Take Control Today
          </Heading>
          <p className="mt-4 text-lg text-gray-700 dark:text-gray-300">
            🔹 Stop stressing over lost documents.
            <br />
            🔹 Keep everything organized & secure.
            <br />
            🔹 Be prepared with CaseTime.
          </p>
          <Button color="green" href="/register" className="w-full mt-6">
            Sign Up for Free
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
